module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "update:returnValue": _vm.setEditItemIdZero
    },
    model: {
      value: (_vm.dialogResult),
      callback: function($$v) {
        _vm.dialogResult = $$v
      },
      expression: "dialogResult"
    }
  }, [_c('v-card', [_c('v-card-text', [_vm._t("CaseAndAmount", null, {
    "casesList": _vm.casesList,
    "selectedCase": _vm.selectedCase,
    "amount": _vm.amount
  }), _vm._v(" "), _vm._t("ItemsSelection", null, {
    "selectedItemType": _vm.selectedItemType,
    "inventoriesList": _vm.inventoriesList,
    "servicesList": _vm.servicesList,
    "caseManagersList": _vm.caseManagersList,
    "selectedInventory": _vm.selectedInventory,
    "selectedService": _vm.selectedService,
    "selectedCaseManager": _vm.selectedCaseManager
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.selectedList,
      "label": "Select items"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n          ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n          ")]
      }
    }]),
    model: {
      value: (_vm.selectedEntity),
      callback: function($$v) {
        _vm.selectedEntity = $$v
      },
      expression: "selectedEntity"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-menu', {
    model: {
      value: (_vm.menuDateStart),
      callback: function($$v) {
        _vm.menuDateStart = $$v
      },
      expression: "menuDateStart"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Select start date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.date.dateStart),
      callback: function($$v) {
        _vm.$set(_vm.date, "dateStart", $$v)
      },
      expression: "date.dateStart"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": ""
    },
    model: {
      value: (_vm.date.dateStart),
      callback: function($$v) {
        _vm.$set(_vm.date, "dateStart", $$v)
      },
      expression: "date.dateStart"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false
    },
    model: {
      value: (_vm.menuTimeStart),
      callback: function($$v) {
        _vm.menuTimeStart = $$v
      },
      expression: "menuTimeStart"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Select start time",
      "prepend-icon": "alarm",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.date.timeStart),
      callback: function($$v) {
        _vm.$set(_vm.date, "timeStart", $$v)
      },
      expression: "date.timeStart"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    model: {
      value: (_vm.date.timeStart),
      callback: function($$v) {
        _vm.$set(_vm.date, "timeStart", $$v)
      },
      expression: "date.timeStart"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-menu', {
    model: {
      value: (_vm.menuDateEnd),
      callback: function($$v) {
        _vm.menuDateEnd = $$v
      },
      expression: "menuDateEnd"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Select end date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.date.dateEnd),
      callback: function($$v) {
        _vm.$set(_vm.date, "dateEnd", $$v)
      },
      expression: "date.dateEnd"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": ""
    },
    model: {
      value: (_vm.date.dateEnd),
      callback: function($$v) {
        _vm.$set(_vm.date, "dateEnd", $$v)
      },
      expression: "date.dateEnd"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false
    },
    model: {
      value: (_vm.menuTimeEnd),
      callback: function($$v) {
        _vm.menuTimeEnd = $$v
      },
      expression: "menuTimeEnd"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Select end time",
      "prepend-icon": "alarm",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.date.timeEnd),
      callback: function($$v) {
        _vm.$set(_vm.date, "timeEnd", $$v)
      },
      expression: "date.timeEnd"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    model: {
      value: (_vm.date.timeEnd),
      callback: function($$v) {
        _vm.$set(_vm.date, "timeEnd", $$v)
      },
      expression: "date.timeEnd"
    }
  })], 1)], 1)], 2), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editItemDataDecorator.apply(null, arguments)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.dialogClose.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-452b9bd9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppEditBookingsBaseDialog.vue
// module id = 953
// module chunks = 1